import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';

export const externalSkuFilterConfig = {
    key: 'externalSku',
    label: 'External SKU',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter external SKU…',
    },
};

export const timestampRangeFilterConfig = {
    key: 'timestampRange',
    label: 'Timestamp',
    type: FilterType.DATE_RANGE,
    includeTime: true,
    deletable: true,
};

export const OosLogFilterConfigArray = [externalSkuFilterConfig, timestampRangeFilterConfig];
